import ar from "./ar.json";
import en from "./en.json";

export type Locale = "en" | "ar";
export type MessageKey = keyof typeof en;

const tables: Record<Locale, Record<string, string>> = { en: en, ar: ar };

let current: Locale = "en";
const listeners = new Set<(l: Locale) => void>();

export function locale(): Locale {
  return current;
}
export function dir(l: Locale = current): "ltr" | "rtl" {
  return l === "ar" ? "rtl" : "ltr";
}
export function setLocale(l: Locale): void {
  current = l;
  for (const fn of listeners) fn(l);
}
export function onLocaleChange(fn: (l: Locale) => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/** Pick the initial locale: ?lang=, then saved, then browser language. */
export function detectLocale(search: string, saved: string | null, navLang: string): Locale {
  const q = new URLSearchParams(search).get("lang");
  if (q === "ar" || q === "en") return q;
  if (saved === "ar" || saved === "en") return saved;
  return navLang.toLowerCase().startsWith("ar") ? "ar" : "en";
}

/** Translate with {param} interpolation; falls back to English, then the key itself. */
export function t(key: string, params: Record<string, string | number> = {}, l: Locale = current): string {
  const k = String(key);
  const s = tables[l][k] ?? tables.en[k] ?? k;
  return s.replace(/\{(\w+)\}/g, (_m: string, name: string) => (params[name] === undefined ? `{${name}}` : String(params[name])));
}

export function missingKeys(): { locale: Locale; keys: string[] }[] {
  const enKeys = Object.keys(en);
  return (["ar"] as Locale[]).map((l) => ({ locale: l, keys: enKeys.filter((k) => !(k in tables[l])) }));
}
